/** TypedConfirmationField — exact-match "JE COMPRENDS" gate. */
import React, { useState, useEffect } from "react";
import { Input } from "../ui/input";
import { Alert, AlertDescription } from "../ui/alert";
import { AlertTriangle } from "lucide-react";

const REQUIRED = "JE COMPRENDS";

export default function TypedConfirmationField({ onConfirm }) {
  const [value, setValue] = useState("");
  useEffect(() => {
    onConfirm?.(value === REQUIRED, value);
  }, [value, onConfirm]);
  return (
    <Alert variant="destructive" className="border-red-300 bg-red-50">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="space-y-2">
        <p>
          <strong>Attention</strong> — Cette mise à jour contient une ou plusieurs migrations non réversibles.
          Un rollback applicatif ultérieur pourra nécessiter la <strong>restauration manuelle d'un backup Mongo
          antérieur</strong> pour retrouver un état cohérent. Pour continuer, tapez exactement
          {' '}<code className="bg-red-100 px-1 rounded">JE COMPRENDS</code> ci-dessous.
        </p>
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={REQUIRED}
          className="bg-white"
          autoComplete="off"
          spellCheck={false}
          data-testid="typed-confirmation"
        />
      </AlertDescription>
    </Alert>
  );
}
